import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import { addSubject, getAllSubjects, createClass } from '../../api/dashboardApi';
import CreateClass from './CreateClass';
import NoPermission from '../../common/NoPermission';

class SubjectClass extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
			subject: '',
			displayStatus: true,
			timeOutSet: false,
			subjectCategory:"",
			subjectFees: 0,
			customSubjectFee: 0
		};
	}

	componentDidUpdate() {
		const { addingSubject, subjectApiCalled } = this.props;
		const { displayStatus, timeOutSet } = this.state;
		if (!addingSubject && displayStatus && !timeOutSet && subjectApiCalled) {
			setTimeout(() => {
				this.setState({ displayStatus: false });
			}, 2000);
			this.setState({ timeOutSet: true });
		}
	}

	handleAddSubject = () => {
		const { userProfile = {}, addSubject } = this.props;
		const { _id, full_name: { first_name, last_name } = {} } = userProfile;
		const payload = {
			name: this.state.subject,
			created_by: _id,
			admin_name: `${first_name} ${last_name}`,
			subjectCategory: this.state.subjectCategory,
			subjectFees: parseInt(this.state.subjectFees, 10)
		};
		console.log(payload);
		const callback = () => this.setState({ subject: '', subjectCategory: '', subjectFees: 0 });
		this.setState({ displayStatus: true, timeOutSet: false });
		addSubject(payload, callback);
	}

	setCustomSubjectFee = (fee = 0) => {
		this.setState({customSubjectFee: fee});
	}

	renderHeader = () => {
		const { activeTab } = this.state;
		const { permissions = {}, isSuperAdmin } = this.props;
		const selectedTab = activeTab === 1 ? 'Subject' : 'Class';

		return (
			<Fragment>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Subject and Class</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><span>St. Andrews College</span></li>
									<li className="breadcrumb-item active" aria-current="page">{selectedTab}</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								<NavItem>
									<NavLink
										className={classnames({ active: activeTab === 1 })}
										onClick={() => this.setState({ activeTab: 1 })}
									>
										Create Subject
									</NavLink>
								</NavItem>
								<NavItem style={{ display: "block" }}>
									<NavLink
										className={classnames({ active: activeTab === 2 })}
										onClick={() => this.setState({ activeTab: 2 })}
									>
										Create Class
									</NavLink>
								</NavItem>
							</Nav>
						</div>
						{(!isSuperAdmin && !permissions.create) && <div className='mt-2' style={{ color: "red" }}>*Note: You don't have permission to create/update subject and class.</div>}
					</div>
				</div>
			</Fragment>
		);
	}

	renderSubjectSection = () => {
		const { subject = '', displayStatus, subjectCategory, subjectFees = 0 } = this.state;
		const { addingSubject = false, isAddSubjectSuccess, subjectApiCalled, isSuperAdmin, permissions = {} } = this.props;
		const status = isAddSubjectSuccess ? 'Success' : 'Failed';
		const color = isAddSubjectSuccess ? 'limegreen' : 'red';
		return (
			<Fragment>
				<TabPane tabId={1} className={classnames(['fade show'])}>
					<div className="card">
						<div className="card-header">
							<h3 className="card-title">Create Subject</h3>
							{(subjectApiCalled && displayStatus) && <div className='status' style={{ background: color }}>{status}</div>}
						</div>
						<form className="card-body">
							<div className="form-group row">
								<label className="col-md-3 col-form-label">Subject Name <span className="text-danger">*</span></label>
								<div className="col-md-7 mb-3">
									<input placeholder='English' type="text" className="form-control" value={subject} onChange={(e) => this.setState({ subject: e.target.value })} />
								</div>
							</div>
							<div className="form-group row">
								<label className="col-md-3 col-form-label">Subject category</label>
								<div className="col-md-7">
									<div className="input-group mb-3">
										<select type="select" className="form-control" value={subjectCategory} onChange={(e) => this.setState({ subjectCategory: e.target.value })} >
											<option value="">Select Category</option>
											<option value="Self Funded">Self Funded</option>
              								<option value="Government Aided">Government Aided</option>
										</select>
									</div>
								</div>
							</div>
							<div className="form-group row">
								<label className="col-md-3 col-form-label">Subject fees (optional)</label>
								<div className="input-group col-md-7 mb-3">
									<div className="input-group-prepend">
										<span className="input-group-text">&nbsp;&#8377;</span>
									</div>
									<input type="number" className="form-control" value={subjectFees} onChange={(e) => this.setState({ subjectFees: e.target.value })} />
								</div>
							</div>
							<div className="form-group row">
								<label className="col-md-3 col-form-label"></label>
								<div className="col-md-7">
									<button
										className="mr-3 btn btn-primary"
										onClick={this.handleAddSubject}
										disabled={(!isSuperAdmin && !permissions.create) || !subject}
										type='button'
										style={{ width: "72px" }}
									>
										{addingSubject ? <i className="fa fa-circle-o-notch fa-spin fa-fw"></i> : 'Submit'}
									</button>
									<button
										className="btn btn-outline-secondary"
										type='button'
										onClick={() => this.setState({ subject: '' })}
										disabled={addingSubject}
									>
										Discard
									</button>
								</div>
							</div>
						</form>
					</div>
				</TabPane>
			</Fragment>
		);
	}

	renderClassSection = () => {
		if (this.state.activeTab !== 2) return null;
		const { allSubjects, getAllSubjects, createClass, creatingClass, permissions = {}, isSuperAdmin, fetchingSubjects } = this.props;
		return (
			<CreateClass
				getAllSubjects={getAllSubjects}
				subjectList={allSubjects}
				createClass={createClass}
				creatingClass={creatingClass}
				permissions={permissions}
				isSuperAdmin={isSuperAdmin}
				fetchingSubjects={fetchingSubjects}
				customSubjectFee={this.state.customSubjectFee}
				setCustomSubjectFee={this.setCustomSubjectFee}
			/>
		);
	}

	render() {
		const { activeTab } = this.state
		const { permissions = {}, isSuperAdmin } = this.props;
		if (!isSuperAdmin && !permissions.read) {
			return <NoPermission />;
		}
		return (
			<>
				{this.renderHeader()}
				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>
							{this.renderSubjectSection()}
							{this.renderClassSection()}
						</TabContent>
					</div>
				</div>

			</>
		);
	}
}

const mapStateToProps = state => ({
	userProfile: state.authenticationReducer.userProfile,
	addingSubject: state.dashboardReducer.addingSubject,
	isAddSubjectSuccess: state.dashboardReducer.isAddSubjectSuccess,
	subjectApiCalled: state.dashboardReducer.subjectApiCalled,
	allSubjects: state.dashboardReducer.allSubjects,
	creatingClass: state.dashboardReducer.creatingClass,
	fetchingSubjects: state.dashboardReducer.fetchingSubjects
})

const mapDispatchToProps = dispatch => ({
	addSubject: (e, cb) => dispatch(addSubject(e, cb)),
	getAllSubjects: () => dispatch(getAllSubjects()),
	createClass: (e, cb) => dispatch(createClass(e, cb)),
	dispatch
})
export default connect(mapStateToProps, mapDispatchToProps)(SubjectClass);
